import {
  HANDOVER_CARS_LOCATIONS,
  PROCUREMENT_STAGES,
  RESERVATIONS_TYPES,
  SUBSCRIPTIONS_BUNDLES_STATUSES,
  SUBSCRIPTIONS_BUNDLES_TYPES,
  SUBSCRIPTIONS_STATUSES,
  SUBSCRIPTIONS_TYPES,
} from '@constants';

export const subscriptionStatusOptions = Object.keys(
  SUBSCRIPTIONS_STATUSES
).map((key) => ({
  text: SUBSCRIPTIONS_STATUSES[key],
  value: key,
}));

export const ERFUDD_RESERVATION_TYPE = RESERVATIONS_TYPES.booked;
export const ERFUDD_STATUS = { text: 'For Delivery', value: '1' };

export const procurementStages = Object.keys(PROCUREMENT_STAGES).map((key) => ({
  value: PROCUREMENT_STAGES[key],
  text: key.toLowerCase(),
}));

export const typeOptions = Object.keys(SUBSCRIPTIONS_TYPES).map((key) => ({
  text: SUBSCRIPTIONS_TYPES[key],
  value: key,
}));

export const deliveryLocationOptions = Object.keys(HANDOVER_CARS_LOCATIONS).map(
  (key) => ({
    text: HANDOVER_CARS_LOCATIONS[key],
    value: HANDOVER_CARS_LOCATIONS[key],
  })
);

export const BUNDLE_TYPE_OPTIONS = Object.keys(SUBSCRIPTIONS_BUNDLES_TYPES).map(
  (key) => ({
    text: SUBSCRIPTIONS_BUNDLES_TYPES[key],
    value: SUBSCRIPTIONS_BUNDLES_TYPES[key],
  })
);

export const BUNDLE_STATUS_OPTIONS = Object.keys(
  SUBSCRIPTIONS_BUNDLES_STATUSES
).map((key) => ({
  text: SUBSCRIPTIONS_BUNDLES_STATUSES[key],
  value: key,
}));
